import searchIcon from "../assets/images/search6.png";
import React, { useState, useEffect } from "react";

// Content Loader Component
const ContentLoader = ({ isMobile }) => {
  const shimmerAnimation = `
    @keyframes shimmer {
      0% {
        background-position: -468px 0;
      }
      100% {
        background-position: 468px 0;
      }
    }
  `;

  const loaderStyles = {
    container: {
      padding: "20px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      backgroundColor: "#fff",
      position: "relative",
    },
    line: {
      height: isMobile ? "12px" : "14px",
      borderRadius: "4px",
      marginBottom: "8px",
      backgroundColor: "#e0e0e0",
      backgroundImage: "linear-gradient(to right, #f0f0f0 0%, #e8e8e8 20%, #f0f0f0 40%, #f0f0f0 100%)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "800px 104px",
      animation: "shimmer 1.2s linear infinite",
    },
    heading: {
      width: "70%",
      height: isMobile ? "20px" : "24px",
      borderRadius: "4px",
      marginBottom: "20px",
      backgroundColor: "#e0e0e0",
      backgroundImage: "linear-gradient(to right, #f0f0f0 0%, #e8e8e8 20%, #f0f0f0 40%, #f0f0f0 100%)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "800px 104px",
      animation: "shimmer 1.2s linear infinite",
    },
  };

  return (
    <>
      <style>{shimmerAnimation}</style>
      <div style={loaderStyles.container}>
        <div style={loaderStyles.heading}></div>
        <div style={{ ...loaderStyles.line, width: "100%" }}></div>
        <div style={{ ...loaderStyles.line, width: "80%" }}></div>
        <div style={{ ...loaderStyles.line, width: "90%" }}></div>
        <div style={{ ...loaderStyles.line, width: "75%" }}></div>
        <div style={{ ...loaderStyles.line, width: "85%" }}></div>
      </div>
    </>
  );
};

const HelpRiders = () => {
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isFocused, setIsFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const topics = [
    "Help with a trip",
    "Account",
    "Membership",
    "Accessibility",
    "Grievance redressal",
    "Guides",
  ];

  const topicContent = {
    "Help with a trip": {
      heading: "Cancelling a Trip",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            You can cancel a trip at any time through the Berymo app but may be charged a cancellation fee if you cancel after you’re matched with your driver. Cancellation fees pay drivers for the time and effort they spend getting to your location.
          </p>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Ride requests should only be made when you’re ready to ride and near the pickup location. This helps ensure smooth pickups for drivers and a seamless experience for riders.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Cancellation Fee for Berymo Trips
          </p>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            You may be charged a cancellation fee if:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>You cancel after the grace period of 3 minutes after the driver accepts the trip for all products except Auto, Moto, Connect, and Intercity.</li>
            <li>For Auto, Moto, Connect, and Intercity, the grace period changes to 5 minutes after the driver accepts the trip.</li>
            <li>Your driver cancels after waiting a minimum of 5 minutes at your pickup location.</li>
          </ul>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Cancel a Trip
          </p>
          <p style={{ marginBottom: "8px", fontSize: isMobile ? "16px" : "17px" }}>
            Before a driver accepts your trip request:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Swipe up from the bottom of your screen.</li>
            <li>Tap Cancel, then Confirm.</li>
          </ul>
          <p style={{ marginBottom: "8px", fontSize: isMobile ? "16px" : "17px" }}>
            After a driver accepts your trip:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Swipe up from the bottom of your screen.</li>
            <li>Tap Cancel, then Confirm.</li>
          </ul>
        </>
      ),
    },
    "Account": {
      heading: "Managing Your Account",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            You can manage your Berymo account directly through the app. This includes updating your personal information, payment methods, and preferences.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Update Your Profile:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to the Account section in the app.</li>
            <li>Tap on your profile to edit details like name, email, or phone number.</li>
            <li>Save your changes.</li>
          </ul>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Manage Payment Methods:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Navigate to the Payment section.</li>
            <li>Add, remove, or set a default payment method.</li>
          </ul>
        </>
      ),
    },
    "Membership": {
      heading: "Berymo Membership Benefits",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            A Berymo membership offers exclusive benefits like discounted rides, priority support, and more.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            How to Join:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to the Membership section in the app.</li>
            <li>Choose a plan that suits you.</li>
            <li>Complete the payment to activate your membership.</li>
          </ul>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Cancel Membership:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Visit the Membership section.</li>
            <li>Tap Cancel Membership and confirm.</li>
          </ul>
        </>
      ),
    },
    "Accessibility": {
      heading: "Accessibility Features",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Berymo is committed to providing accessible rides for all users. We offer features to assist riders with disabilities.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Available Features:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Wheelchair-accessible vehicles (WAV) in select cities.</li>
            <li>Voiceover and screen reader support in the app.</li>
            <li>Assistance requests for drivers.</li>
          </ul>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Enable:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to Accessibility settings in the app.</li>
            <li>Toggle on the features you need.</li>
          </ul>
        </>
      ),
    },
    "Grievance redressal": {
      heading: "Filing a Grievance",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            If you have a complaint or issue with your ride, you can file a grievance through the app.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Steps to File a Grievance:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to the Help section in the app.</li>
            <li>Select the trip with the issue.</li>
            <li>Choose "File a grievance" and provide details.</li>
            <li>Submit and await a response from our team.</li>
          </ul>
        </>
      ),
    },
    "Guides": {
      heading: "Rider Guides",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            We provide guides to help you make the most of your Berymo experience.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Available Guides:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>How to book your first ride.</li>
            <li>Tips for a safe and enjoyable trip.</li>
            <li>Understanding fares and payments.</li>
          </ul>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To Access:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Visit the Guides section in the app.</li>
            <li>Select a guide to read.</li>
          </ul>
        </>
      ),
    },
  };

  const handleTopicClick = (topic) => {
    setIsLoading(true);
    setSelectedTopic(topic);
    setIsModalOpen(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 700);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTopic(null);
    setQuery("");
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const filteredTopics = topics.filter((topic) =>
    topic.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#333",
        margin: "0 auto",
      }}
    >
      {/* Header Section - Always visible */}
      <div
        style={{
          backgroundColor: "#FEF4F5",
          padding: isMobile ? "40px 16px" : "60px 0",
          marginTop: isMobile ? "30px" : "0",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "left",
            ...(isMobile ? { paddingLeft: "16px" } : { marginLeft: "360px" }),
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "24px" : "28px",
              fontWeight: "bold",
              marginBottom: "12px",
              color: "#000",
            }}
          >
            Support Resources for Berymo Riders
          </h1>
          <p
            style={{
              fontSize: isMobile ? "14px" : "15px",
              color: "#555",
              lineHeight: "1.5",
              marginBottom: "20px",
            }}
          >
            Looking for contact information? While we don’t offer a customer service number for Berymo riders, you can log in to your account to get personalized support or explore the resources below to find solutions to issues related to Berymo rides.
          </p>
        
          {/* Search Bar */}
          <div style={{ position: "relative", width: isMobile ? "100%" : "550px" }}>
            <span
              style={{
                position: "absolute",
                left: "12px",
                top: "40%",
                transform: "translateY(-50%)",
              }}
            >
              <img
                src={searchIcon}
                alt="Search Icon"
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            <input
              type="text"
              placeholder="Search questions, Keywords,Topics"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={{
                width: isMobile && isFocused ? "100%" : "100%",
                padding: isMobile ? "12px 14px 12px 40px" : "14px 16px 14px 40px",
                border: `1px solid ${isFocused ? '#fd5c63' : '#fff0f1'}`,
                borderRadius: "5px",
                fontSize: isMobile ? "14px" : "16px",
                color: "#333",
                backgroundColor: isFocused ? "#fff" : "#FFFFFF",
                outline: "none",
                transition: "width 0.3s ease, border-color 0.3s ease, background-color 0.3s ease",
              }}
            />
            {/* Conditional 'X' icon */}
            {query && (
              <span
                onClick={() => setQuery("")}
                style={{
                  position: "absolute",
                  right: window.innerWidth <= 768 ? "12px" : "15px",
                  transform: "translateY(-300%)",
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "15px",
                  height: "15px",
                  backgroundColor: "#fd5c63",
                  borderRadius: "50%",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    top: window.innerWidth <= 768 ? "-1px" : "-1px",
                  }}
                >
                  ×
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
      
      {/* Main content area */}
      <div
        style={{
          maxWidth: "800px",
          margin: isMobile ? "0 auto" : "0 0 0 360px",
          padding: isMobile ? "24px 16px 24px 32px" : "40px 0",
        }}
      >
        {isLoading ? (
          <ContentLoader isMobile={isMobile} />
        ) : selectedTopic ? (
          <div
            style={{
              padding: isMobile ? "20px" : "30px",
              borderRadius: isMobile ? "0" : "15px",
              boxShadow: isMobile ? "none" : "0 10px 30px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
              position: isMobile ? "fixed" : "relative",
              top: isMobile ? "0" : "auto",
              left: isMobile ? "0" : "auto",
              width: isMobile ? "100%" : "auto",
              height: isMobile ? "100%" : "auto",
              overflowY: isMobile ? "auto" : "visible",
              zIndex: isMobile ? "1000" : "auto",
              transform: isMobile ? "translateY(0)" : "none",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <button
              style={{
                position: "absolute",
                top: isMobile ? "35px" : "15px",
                right: isMobile ? "-150px" : "-355px",
                background: "none",
                border: "none",
                fontSize: isMobile ? "38px" : "38px",
                fontWeight: "300",
                color: "#000",
                cursor: "pointer",
                padding: "5px",
                zIndex: "1001",
                transition: "color 0.3s, transform 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#fd5c63")}
              onMouseOut={(e) => (e.target.style.color = "#000")}
              onClick={closeModal}
            >
              ×
            </button>
            <h2
              style={{
                fontSize: isMobile ? "24px" : "28px",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#222",
                paddingTop: isMobile ? "30px" : "0",
              }}
            >
              {topicContent[selectedTopic]?.heading}
            </h2>
            <div
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#555",
                lineHeight: "1.6",
              }}
            >
              {topicContent[selectedTopic]?.content}
            </div>
            <button
              style={{
                marginTop: "30px",
                padding: isMobile ? "12px 24px" : "14px 28px",
                backgroundColor: "#fd5c63",
                color: "#fff",
                border: "none",
                borderRadius: "25px",
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "block",
                margin: "30px auto 0",
                transition: "background-color 0.3s, transform 0.2s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#474747";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fd5c63";
                e.target.style.transform = "scale(1)";
              }}
              onClick={() =>
                (window.location.href = "https://play.google.com/store/apps/details?id=com.berymoflat&pli=1")
              }
            >
              Log in to Get Help
            </button>
          </div>
        ) : (
          <div>
            <h2
              style={{
                fontSize: isMobile ? "20px" : "24px",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#000",
                textAlign: "left",
              }}
            >
              All Topics
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {filteredTopics.map((topic, index) => (
                <li
                  key={index}
                  onClick={() => handleTopicClick(topic)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: isMobile ? "16px 0" : "20px 0",
                    borderBottom: "1px solid #eee",
                    fontSize: isMobile ? "14px" : "16px",
                    color: "#000",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")}
                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "10px", fontSize: isMobile ? "18px" : "20px" }}>
                      ≡
                    </span>
                    {topic}
                  </div>
                  <span style={{ fontSize: isMobile ? "18px" : "20px", color: "#999" }}>›</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpRiders;